
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Asset, Workorder, WorkordersApi } from 'performo-api';

import { ColumnDisplayOption } from '@/models/ColumnDisplayOption';

import AddAssetComponent from '@/components/orders/AddAssetComponent.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    AddAssetComponent
  },
  computed: mapGetters({
    api: 'ordersApi'
  })
})
export default class OrderAssetListComponent extends Vue {
  private api!: WorkordersApi;
  private showDialog = false;
  private assetsUnderWarrantyOrService: Asset[] = [];

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({})
  private selectedAssets!: Asset[];

  @Prop({ required: false, default: false, type: Boolean })
  private required!: boolean;

  get assetDisplayOptions(): ColumnDisplayOption[] {
    return [
      { displayName: 'Code', columnName: 'assetCode', dontSort: true },
      { displayName: 'Name', columnName: 'name', dontSort: true },
      { displayName: 'Status', columnName: 'status', dontSort: true },
      { displayName: 'Critical #', columnName: 'criticalNum', dontSort: true },
      {
        displayName: 'Under Warranty',
        columnName: 'warrantyStatus',
        dontSort: true
      },
      {
        displayName: 'Service Agrmt',
        columnName: 'maintAgreementStatus',
        dontSort: true
      },
      {
        displayName: this.$store.state.settings.campusLabelSingular || 'Campus',
        columnName: 'campus',
        dontSort: true
      },
      {
        displayName:
          this.$store.state.currentProperty.location1Label || 'Building',
        columnName: 'location1',
        dontSort: true
      },
      { displayName: 'Floor', columnName: 'floor', dontSort: true },
      {
        displayName: this.$store.state.currentProperty.location2Label || 'Room',
        columnName: 'location2',
        dontSort: true
      }
    ];
  }

  private assetClicked(asset: Asset) {
    if (asset.assetId) {
      this.$router.push({
        name: 'asset-detail',
        params: { id: asset.assetId.toString() }
      });
    }
  }

  private async assetAddedHandler(assets: Asset[]) {
    if (this.order.workorderId) {
      this.assetsUnderWarrantyOrService = [];
      await Promise.allSettled(
        assets.map(async (asset) => {
          if (asset.assetId) {
            try {
              await this.api.addAssetToOrder({
                workorderAssetCreateCommand: {
                  workorderId: this.order.workorderId,
                  assetId: asset.assetId
                }
              });
              this.$emit('assetAdded', asset.assetId);
              // check if the asset is currently under
              // a service contract or warranty
              if (asset.isUnderWarranty || asset.isUnderMaintAgreement) {
                this.assetsUnderWarrantyOrService.push(asset);
              }
            } catch (error) {
              this.$emit('error', error);
            }
          }
        })
      );
      if (this.assetsUnderWarrantyOrService.length) {
        this.showDialog = true;
      }
    } else {
      this.$emit('assets-picked', assets);
    }
  }

  private closeDialog() {
    this.showDialog = false;
    this.assetsUnderWarrantyOrService = [];
  }
}
